import React from 'react';
import { useUserStore } from './stores/userStore';
import AccessDenied from './pages/AccessDenied';

const AdminRoute = ({ children }) => {
  const { isAdmin, loading } = useUserStore();

  // 로딩 중일 때는 아무것도 렌더링하지 않음
  if (loading) {
    return null;
  }

  // admin이 아닌 경우 AccessDenied 페이지 표시
  if (!isAdmin) {
    return <AccessDenied />;
  }

  // admin인 경우 원래 컴포넌트 렌더링
  return children;
};

export default AdminRoute;
